<template>
    <v-form-element :label-container-class-name="labelContainerClassName" :label-class-name="labelClassName + ' flex-1'" v-bind="$props">
        <template slot="after-label">
            <slot name="before-menu-bar"></slot>
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                <div :class="menuBarClassName">

                    <slot name="before-menu-bar-elements"></slot>
                    
                    <template v-if="menuBarOpened">

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.bold() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.bold"
                        >
                            <i class="fas fa-bold"></i>
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.italic() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.italic"
                        >
                            <i class="fas fa-italic"></i>
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.strike() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.strike"
                        >
                            <i class="fas fa-strikethrough"></i>
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.underline() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.underline"
                        >
                            <i class="fas fa-underline"></i>
                        </button>

                        <!-- <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.code() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.code"
                        >
                            <>
                        </button>
                        
                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.paragraph() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.paragraph"
                        >
                            P
                        </button> -->

                        <!-- <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.heading({ level: 1 }) ? 'bg-gray-200' : '']"
                            @click.prevent="commands.heading({ level: 1 })"
                        >
                            H1
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.heading({ level: 2 }) ? 'bg-gray-200' : '']"
                            @click.prevent="commands.heading({ level: 2 })"
                        >
                            H2
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.heading({ level: 3 }) ? 'bg-gray-200' : '']"
                            @click.prevent="commands.heading({ level: 3 })"
                        >
                            H3
                        </button> -->

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.bullet_list() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.bullet_list"
                        >
                            <i class="fas fa-list-ul"></i>
                        </button>

                        <!-- <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.ordered_list() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.ordered_list"
                        >
                            ol
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.blockquote() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.blockquote"
                        >
                            quote
                        </button>

                        <button
                            type="button"
                            :class="[menuBarButtonClassName, isActive.code_block() ? 'bg-gray-200' : '']"
                            @click.prevent="commands.code_block"
                        >
                            code
                        </button>

                        <button
                            type="button"
                            :class="menuBarButtonClassName"
                            @click.prevent="commands.horizontal_rule"
                        >
                            hr
                        </button>

                        <button
                            type="button"
                            :class="menuBarButtonClassName"
                            @click.prevent="commands.undo"
                        >
                            undo
                        </button>

                        <button
                            type="button"
                            :class="menuBarButtonClassName"
                            @click.prevent="commands.redo"
                        >
                            redo
                        </button> -->

                    </template>

                    <button
                        type="button"
                        :class="menuBarButtonClassName"
                        @click.prevent="menuBarOpened = ! menuBarOpened"
                    >
                        <template v-if="menuBarOpened"><i class="fas fa-angle-right"></i></template>
                        <template v-else><i class="fas fa-angle-left"></i></template>
                    </button>

                    <slot name="after-menu-bar-elements"></slot>

                </div>
            </editor-menu-bar>
            <slot name="after-menu-bar"></slot>
        </template>
        <editor-content :class="inputClassName" :editor="editor" />
        <!-- <v-textarea @updated="$emit('updated')" v-bind="$props"></v-textarea> -->
    </v-form-element>
</template>

<style>
    .ProseMirror {
        min-height: 100px;
    }
    .ProseMirror-focused {
        outline: none;
    }

    .ProseMirror ul {
        padding-left: 20px;
        list-style-type: disc;
    }
</style>

<script>
    import mixin from './mixin';
    import Element from './Element';
    import Textarea from './Textarea';
    import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
    } from 'tiptap-extensions'
    export default {
        components: {
            'v-form-element': Element,
            'v-textarea': Textarea,
            EditorContent,
            EditorMenuBar
        },
        mixins: [mixin],
        props: {
            inputClassName: {
                type: String,
                default() {
                    return this.$spa.css.form.input_full_width + ' min-h-32';
                }
            },
            labelContainerClassName: {
                type: String,
                default() {
                    return 'w-full flex items-center';
                }
            },
            menuBarClassName: {
                type: String,
                default() {
                    return 'flex';
                }
            },
            menuBarButtonClassName: {
                type: String,
                default() {
                    return 'p-1 outline-none bg-gray-100 hover:bg-gray-200 text-sm text-gray-600 w-8 h-8';
                }
            }
        },
        data() {
            return {
                editor: null,
                menuBarOpened: false,
                json: null
            }
        },
        methods: {
            update(value)
            {
                this.editor.setContent(value);
            } 
        },
        mounted() {
            this.editor = new Editor({
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({ levels: [1, 2, 3] }),
                    new HorizontalRule(),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link(),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Strike(),
                    new Underline(),
                    new History(),
                ],
                content: this.model,
                onFocus: () => {
                    this.$emit('focus');
                },
                onBlur: () => {
                    this.$emit('blur');
                },
                onUpdate: ({ getJSON, getHTML }) => {
                    this.json = getJSON();
                    this.model = getHTML();
                },
            })
        },
        beforeDestroy() {
            this.editor.destroy();
        },
    }
</script>